<template>
  <v-container fluid>
    <alert-error :error="error"></alert-error>
    <v-toolbar>
      <v-toolbar-title>{{
        $t('NAVIGATION.BOOKING_RESERVATIONS')
      }}</v-toolbar-title>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <v-row>
        <v-col cols="12">
          <booking-reservations-list-filter @setFilters="setFilters" />
        </v-col>
        <v-col cols="12">
          <booking-reservations-list
            v-if="options"
            :items="items"
            :meta="meta"
            :options.sync="options"
            @show="show"
          ></booking-reservations-list>
        </v-col>
      </v-row>
    </v-sheet>

    <v-dialog v-model="dialog" persistent max-width="800px">
      <view-reservation
        v-if="reservationId"
        :id="reservationId"
        :key="reservationId"
        @updated="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      ></view-reservation>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import BookingReservationsList from '@/modules/booking_reservations/components/BookingReservationsList.vue';
import BookingReservationsListFilter from '@/modules/booking_reservations/components/forms/BookingReservationsListFilter.vue';
import listOptions from '@/modules/_global/mixins/list-options';

export default {
  name: 'BookingReservationsPage',

  components: {
    BookingReservationsList,
    BookingReservationsListFilter,
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    ViewReservation: () =>
      import(
        '@/modules/booking_reservations/components/Reservation/ViewReservation.vue'
      )
  },

  mixins: [errors, listOptions],

  data() {
    return {
      error: null,
      dialog: false,
      reservationId: null,
      options: {
        page: 1,
        itemsPerPage: 100,
        sortBy: ['id'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      }
    };
  },

  computed: {
    ...mapState('booking_reservations', ['paginationOptions'])
  },

  methods: {
    ...mapActions('booking_reservations', ['getItemsList']),
    cancelDialog() {
      this.dialog = false;
      this.reservationId = null;
    },
    show(reservation) {
      this.reservationId = reservation.id;
      this.dialog = true;
    },
    cancelDialogAndRefresh() {
      this.cancelDialog();
      this.options = { ...this.options }; // refresh
    }
  }
};
</script>
